import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiSearch, HiSparkles } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { useDarkMode } from "../../contexts/DarkModeContext";

const SearchBar = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [currentPromptIndex, setCurrentPromptIndex] = useState(0);
  const navigate = useNavigate();
  const { isDarkMode } = useDarkMode();

  const prompts = [
    "Ask me anything…",
    "Who is Lovish Tater?",
    "Show me his resume",
    "Tell me about his skills",
    "How can I contact him?"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPromptIndex((prevIndex) => 
        prevIndex === prompts.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Change every 3 seconds

    return () => clearInterval(interval);
  }, [prompts.length]);

  const handleSearchClick = () => {
    navigate('/chat');
  };

  return (
    <div 
      className="w-full relative"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ position: 'relative', width: '100%' }}
    >
      <div 
        onClick={handleSearchClick}
        style={{
          background: isDarkMode ? 'rgba(255, 255, 255, 0.95)' : 'rgba(99, 102, 241, 0.95)',
          backdropFilter: 'blur(10px)',
          border: '2px solid',
          borderColor: isHovered ? '#6366f1' : (isDarkMode ? '#e2e8f0' : 'rgba(255, 255, 255, 0.3)'),
          borderRadius: '16px',
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: isHovered ? '0 8px 25px rgba(99, 102, 241, 0.15)' : (isDarkMode ? '0 2px 8px rgba(0, 0, 0, 0.05)' : '0 4px 15px rgba(99, 102, 241, 0.2)'),
          width: '100%',
        }}
      >
        {/* Search Icon */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '24px',
          height: '24px',
          color: isHovered ? '#6366f1' : (isDarkMode ? '#64748b' : '#f8fafc')
        }}>
          <HiSearch size={20} />
        </div>

        {/* Search Text with Framer Motion Animation */}
        <div style={{
          flex: 1,
          color: isDarkMode ? '#64748b' : '#f8fafc',
          fontSize: '16px',
          fontWeight: '500',
          minHeight: '24px',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden'
        }}>
          <AnimatePresence mode="wait">
            <motion.span
              key={currentPromptIndex}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ 
                duration: 0.4,
                ease: "easeInOut"
              }}
              style={{
                whiteSpace: 'nowrap',
                position: 'absolute'
              }}
            >
              {prompts[currentPromptIndex]}
            </motion.span>
          </AnimatePresence>
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '2px',
          width: '50px',
          height: '30px',
          backgroundColor: isHovered ? '#6366f1' : (isDarkMode ? '#f1f5f9' : 'rgba(255, 255, 255, 0.25)'),
          borderRadius: '8px',
          color: isHovered ? '#ffffff' : (isDarkMode ? '#6366f1' : '#ffffff'),
          transition: 'all 0.3s ease'
        }}>
          <p style={{
            fontFamily: 'monospace',
            color: isHovered ? '#ffffff' : (isDarkMode ? '#6366f1' : '#ffffff')
          }}>AI</p>
          <HiSparkles size={16} />
        </div>
      </div>
    </div>
  );
};

export default SearchBar; 